<template>
  <div>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Actualización del precio del producto con relación al catálogo
            </div>
            <v-spacer />
          </div>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="productUpdateCatalog"
            v-model="productUpdateCatalog.valid"
          >
            <v-row>
              <v-col cols="12">
                <v-data-table
                  v-model="selected"
                  :loading-text="productUpdateCatalog.table.title"
                  :server-items-length="productUpdateCatalog.table.total"
                  :loading="productUpdateCatalog.table.loading"
                  :headers="productUpdateCatalog.table.headers"
                  :items="productUpdateCatalog.table.data"
                  :options="productUpdateCatalog.table.options"
                  sort-by="product"
                  class="elevation-1"
                  fixed-header
                  hide-default-footer
                  item-key="product"
                  show-select
                >
                  <template v-slot:item.amountInvoice="{ item }">
                    ${{ (item.amountInvoice || 0) | toFixNumber(2) }}
                  </template>
                  <template v-slot:item.amountInvoiceWithTax="{ item }">
                    ${{ (item.amountInvoiceWithTax || 0) | toFixNumber(2) }}
                  </template>
                  <template v-slot:item.amountVariant="{ item }">
                    ${{ (item.amountVariant || 0) | toFixNumber(2) }}
                  </template>
                  <template v-slot:item.amountVariantWithTax="{ item }">
                    ${{ (item.amountVariantWithTax || 0) | toFixNumber(2) }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseProductUpdateCatalog"
          >
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!(selected.length)"
            color="primary"
            rounded
            small
            depressed
            @click="submit">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isOpenDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      productUpdateCatalog: {
        valid: false,
        table: {
          title: 'Loading products',
          loading: false,
          data: [],
          total: 0,
          headers: [
            { text: 'Producto', value: 'name', sortable: false },
            {
              text: 'Precio factura sin impuestos',
              value: 'amountInvoice',
              sortable: false
            },
            {
              text: 'Precio factura con impuestos',
              value: 'amountInvoiceWithTax',
              sortable: false
            },
            {
              text: 'Precio del catálogo sin impuestos',
              value: 'amountVariant',
              sortable: false
            },
            {
              text: 'Precio del catálogo con impuestos',
              value: 'amountVariantWithTax',
              sortable: false
            }
          ],
          options: {
            itemsPerPage: 15,
            page: 1
          }
        },
        rules: {
          required: [(v) => !!v || this.$t('validations.required')]
        }
      },
      overlay: false,
      selected: []
    }
  },
  watch: {
    isOpenDialog: async function (val) {
      this.isOpen = val
      this.productUpdateCatalog.table.loading = true
      this.productUpdateCatalog.table.data = this.data
      this.productUpdateCatalog.table.total = this.data.length
      this.productUpdateCatalog.table.loading = false
    }
  },
  methods: {
    onCloseProductUpdateCatalog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    async submit () {
      if (this.$refs.productUpdateCatalog.validate()) {
        this.overlay = true
        const variants = this.selected.map(x => ({
          product: x.product,
          choice: x.choice,
          newPrice: x.amountInvoice,
          taxes: x.taxes
        }))
        try {
          await this.$api.put(`/v1/catalog/propagate-amount`, { variants: variants })
          this.$toasted.show('Se han actualizado los precios del catálogo', { duration: 3000 })
          this.onCloseProductUpdateCatalog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    }
  }
}
</script>
